// src/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useStore } from "./store";

export default function ProtectedRoute({ children }) {
  const { state } = useStore();
  if (!state.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return children;
}
